import { render, staticRenderFns } from "./SenderInformationPage.vue?vue&type=template&id=1b451902"
import script from "./SenderInformationPage.vue?vue&type=script&lang=js"
export * from "./SenderInformationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports